import UrlService from '../url/urlService';
import UrlUtils from '../../../utils/http/url';


class Settings {

	constructor() {

		// TODO set default baseUrl
		this.props  = {};
		UrlUtils.addGlobalPathParams({
			accountId: this.getTenantOrganizationId(),
			domainName: this.getDomainName(),
			applicationKey: this.getApplicationKey(),
			agentSessionId: this.getAgentSessionId()
		});

		let baseUrl = UrlService.getSearchParam('baseUrl');
		if(baseUrl) {
			UrlUtils.setBaseUrl(baseUrl);
		}
	}

	set(settings) {
		if(settings.baseUrl) {
			this.baseUrl = settings.baseUrl;
			UrlUtils.setBaseUrl(settings.baseUrl);
		}

		if(settings.accountId) {
			this.accountId = settings.accountId;
		}

		if(settings.appKey) {
			this.appKey = settings.appKey;
		}

		if(settings.environmentName) {
			this.environmentName = settings.environmentName;
		}

		if(settings.language){
			this.language = settings.language;
		}

		if(settings.domainName) {
			this.domainName = settings.domainName;
		}

		if(settings.variables) {
			this.variables = settings.variables;
		}

		UrlUtils.addGlobalPathParams({
			accountId: this.getTenantOrganizationId(),
			domainName: this.getDomainName(),
			applicationKey: this.getApplicationKey(),
			agentSessionId: this.getAgentSessionId()
		});
	}

	getTenantOrganizationId() {
		let tenantName = this.accountId || UrlService.getSearchParam('accountId');
		return tenantName;
	}

	getApplicationKey() {
		let appkey = this.appKey || UrlService.getSearchParam('appkey');
		if(!appkey) {
			//throw new Error('missing appkey in the url');
		}
		return appkey;
	}

	getEnvironmentName() {
		let environmentName = this.environmentName || UrlService.getSearchParam('Environment-Name');
		if(!environmentName) {
			environmentName = 'Dev'
		}
		return environmentName;
	}

	getLanguage(){
		let language = this.language || UrlService.getSearchParam("Language");
		if(!language){
			language = 'English-US'
		}
		return language;
	}

	getDomainName() {
		let domainName = this.domainName || UrlService.getSearchParam('domainName') || UrlService.getSearchParam('vaName');
		return domainName;
	}

	getAgentSessionId() {
		let agentSessionId = this.agentSessionId || UrlService.getSearchParam('agentSessionId');
		return agentSessionId;
	}

	isDebugMode() {
        let mode = UrlService.getSearchParam('mode');

        if (mode) {
            switch (mode.toLowerCase()) {
                case "admin":
                case "designer":
                    return true;

                default:
                    return false;
            }
        }
        else {
        	return false;
		}
	}

	setUbot(isUbot){
		this.isUbot = isUbot
	}

	getUbot(){
		return this.isUbot;
	}

	setSessionId(sessionId) {

		this.sessionId = sessionId;

		UrlUtils.addGlobalQueryParams({sessionId: this.sessionId});
	}

	getSessionId(){
		return this.sessionId;
	}

	getBaseUrl(){
		return this.baseUrl;
	}

	setProp(key, value){
		this.props[key] = value;
	}

	getProp(key){
		return this.props[key];
	}

	getVariables() {
		return this.variables;
	}
}

export default new Settings();


// WEBPACK FOOTER //
// ../common/services/src/settings/settings.js